<!-- components/LanguageSwitcher.vue -->
<template>
  <div class="language-switcher">
    <button 
      @click="setLanguage('fr')"
      :class="['lang-btn', { active: isCurrentLanguage('fr') }]"
      :title="currentLanguage === 'fr' ? 'Français' : 'French'">
      🇫🇷 FR
    </button>
    <button 
      @click="setLanguage('en')"
      :class="['lang-btn', { active: isCurrentLanguage('en') }]"
      :title="currentLanguage === 'en' ? 'English' : 'Anglais'">
      🇺🇸 EN
    </button>
  </div>
</template>

<script>
import { useTranslation } from '@/composables/useTranslation'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { setLanguage, isCurrentLanguage, currentLanguage } = useTranslation()
    
    return {
      setLanguage,
      isCurrentLanguage,
      currentLanguage
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}

.lang-btn {
  padding: 0.375rem 0.75rem;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  color: #666;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
}

.lang-btn:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
}

.lang-btn.active {
  background: #000;
  color: white;
  border-color: #000;
}

.lang-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

/* Mobile optimizations */
@media (max-width: 991px) {
  .lang-btn {
    font-size: 0.8rem;
    min-width: 50px;
    padding: 0.3rem 0.6rem;
  }
}

@media (max-width: 576px) {
  .lang-btn {
    font-size: 0.75rem;
    min-width: 45px;
    padding: 0.25rem 0.5rem;
  }
}
</style>